import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetBehaviorSettings as GetBehaviorSettingsQuery,
    GetBehaviorSettings_chatSettings as ChatSettings,
} from 'nutshell-graphql-types';

import GET_BEHAVIOR_SETTINGS from '../queries/get-chat-behavior-settings.graphql';

export const useGetBehaviorSettings = (): {
    chatSettings: ChatSettings | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetBehaviorSettingsQuery, Record<any, any>>(
        GET_BEHAVIOR_SETTINGS
    );

    return {
        chatSettings: data && data.chatSettings,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
